<app-card-widget title="End Customer Payments" *ngIf="data$ | async as data">

  <form [formGroup]="form" id="payment-history-form" (ngSubmit)="save()" novalidate>

    <div class="card-section-container">

      <div class="card-section">

        <mat-nav-list>
          <mat-list-item *ngFor="let item of data.paymentHistories" (click)="itemClicked(item)" [class.mat-elevation-z2]="item === selectedItem">
            <mat-icon matListIcon>payment</mat-icon>
            <h3 matLine>{{ item.sum | currency:'EUR' }}</h3>
            <span matLine>{{item.payment ? 'Payment' : 'Compensation'}}</span>
            <div class="list-item-timestamp">{{item.changed | date:'shortDate'}}</div>
          </mat-list-item>
        </mat-nav-list>

      </div>
      <div class="card-section" *ngIf="selectedItem || added">

        <app-text label="Amount" *ngIf="!added">{{selectedItem.sum | currency:'EUR'}}</app-text>

        <mat-form-field *ngIf="added">
          <input matInput type="number" placeholder="Amount" formControlName="sum"/>
        </mat-form-field>

        <app-text label="Date" *ngIf="!added">{{selectedItem.changed | date:'shortDate'}}</app-text>

        <mat-form-field *ngIf="added">
          <input matInput [matDatepicker]="changedDatePicker" placeholder="Date" formControlName="changed" />
          <mat-datepicker-toggle matSuffix [for]="changedDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #changedDatePicker></mat-datepicker>
        </mat-form-field>

        <app-text label="Type" *ngIf="!added">
          <span *ngIf="selectedItem.payment">Payment</span>
          <span *ngIf="!selectedItem.payment">Compensation</span>
        </app-text>

        <mat-form-field *ngIf="added">
          <mat-select placeholder="Type" formControlName="payment">
            <mat-option *ngFor="let choice of typeChoices" [value]="choice.value">
              {{choice.label}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <app-text label="User" *ngIf="!added">{{data.users.get(selectedItem.userId)?.name}}</app-text>

        <app-text label="Description" *ngIf="!added">{{selectedItem.description}}</app-text>

        <mat-form-field *ngIf="added">
          <input matInput placeholder="Description" formControlName="description"/>
        </mat-form-field>

        <app-text label="Created" *ngIf="!added">{{selectedItem.created | date:'medium'}}</app-text>

      </div>

    </div>

  </form>

  <mat-card-actions align="end">
    <button type="button" mat-button *ngIf="!added && !added" [disabled]="locked" (click)="add()">Add</button>
    <button type="submit" mat-button *ngIf="added" [disabled]="!form.valid || saving" form="payment-history-form">Save</button>
    <button type="reset" mat-button *ngIf="added" (click)="revert()">Cancel</button>
  </mat-card-actions>

</app-card-widget>


